<template>
  <div class="app-container app-page">
    <div class="app-header">
      <van-nav-bar :title="$t('my.online_service')" class="app-nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>
    <div class="online-support-page__service-list-item">
        <div class="online-support-page__service-list-item-header">
          <img class="online-support-page__service-list-item-image" src="/img/mine/kefu.png">
          <div class="online-support-page__servicelist-item-text">{{this.$store.getters.getBaseInfo.name !==undefined ?this.$store.getters.getBaseInfo.name:this.$t("my.title")}}</div>
          <div class="online-support-page__service-list-item-button" @click="toServicePage()">
            <div class="online-support-page__servicelist-item-btn-text">
              {{$t("my.contact")}}
            </div>
          </div>
        </div>
        <div class="online-support-page__service-list-item-footer">
        <div class="online-support-page__servicelist-item-info-text">
          {{$t("my.service_time")}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    toServicePage(){
      const service = this.$store.getters.getBaseInfo;
      if (service.iskefu == 1){
        window.location.href = service.kefu
      }
      // this.$router.push("/support/page");
    }
  }
};
</script>

<style lang='less' scoped src="./ServiceOnline.styles.less"></style>
